import Svg from 'components/utilities/svg'

const AxisIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Axis Icon</title>
    <path d="M13,3 L13.0004264,3.15998383 C13.0007555,3.16009681 13.0010845,3.16020985 13.0014135,3.16032296 L13,12 L17,16 L21,19.9248301 L21,21 L18.9214891,21 L16,17.95 L12,13.95 L8,17.95 L4.98869092,21 L3,21 L3,20.0807487 L7,16 L11,12 L10.999582,3.15998093 L11,3.159 L11,3 L13,3 Z" />
  </Svg>
)

AxisIcon.displayName = 'Axis'

export default AxisIcon
